import { CustomerLegalForm } from 'src/app/parametrage/core/model/customer-legal-form';
import { ActivityArea } from 'src/app/parametrage/core/model/activity-area';
import { ProfessionnelFaciliteItem } from './professionnel-facilite-item';
import { GarantieModel } from 'src/app/core/models/garantie-model';

export class CreateDossierProfessionnel
{
    underType:String;
    categorie:String;
    dateReceptionDossier:String;
    accountNumber:String;
    customerCode:String;
    number:String;
    ncc:String;
    tradeRegister: String;
    corporateName:String;
    sigle:String;
    capitalSocial:number;
    city:String;
    address:String;
    email:String;
    telephone:String;
    formeJuridique:CustomerLegalForm;
    secteur:ActivityArea;
    firstName:String;
    lastName:String;
    fonction:String;
    experience:number;
    emailDirigeant:String;
    telephoneDirigeant:String;
    facilites:ProfessionnelFaciliteItem[];
    garanties: GarantieModel[];
    requestIdParent : String;
}